$(document).ready(function(){

	var slickPostersSettings = {
		autoplay: true,
		autoplaySpeed: 3000,
		arrows: false,
		dots: true,
	};
  $('.slick__posters').slick(slickPostersSettings);

});